import { reactive } from 'vue'
import type { Ref } from 'vue'

interface EmbedController {
  play: () => void
  pause: () => void
  seek: (seconds: number) => void
  getDuration: () => number
  loadUri: (v: string) => void
  togglePlay: () => void
}
interface SpotifyStore {
  embedController: EmbedController | null
  initialized: boolean
  currentSeconds: number
  duration: number
  isPaused: boolean
  isBuffering: boolean
  currentPodcast: string
  added: boolean
  location: string
  IFrameAPI: Ref<any> | null
  hasPodcastBlock: boolean
}

export const spotifyStore: SpotifyStore = reactive({
  embedController: null,
  initialized: false,
  currentSeconds: 0,
  duration: 0,
  isPaused: true,
  isBuffering: false,
  currentPodcast: '',
  added: false,
  location: '',
  IFrameAPI: null,
  hasPodcastBlock: false,
})
